export default __webpack_public_path__ + "static/media/memoji-3.e58dc76b.png";